export const virtualizedListAnimationOffsetTopVar = '--virtualized-list-animation-offset-top'
